"use client";

import React, { startTransition, useActionState, useId } from "react";
import { submitArticleNewsletter } from "@/actions/article-newsletter";

export default function ArticleNewsletterForm({
  recaptchaSiteKey,
}: {
  recaptchaSiteKey: string;
}) {
  const [state, action, pending] = useActionState(submitArticleNewsletter, {
    success: false,
    message: "",
  });
  const id = useId();
  return (
    <form
      action={async (data) => {
        try {
          data.append(
            "recaptchaToken",
            await grecaptcha.enterprise.execute(recaptchaSiteKey, {
              action: "ContactForm",
            }),
          );
        } catch {
          /* Normal server-side CAPTCHA validation remains authoritative. */
        }
        startTransition(() => action(data));
      }}
      className="a-newsletter"
      aria-label="Anmod om nyhedsbrevstilmelding"
    >
      {state.success ? (
        <p role="status">{state.message}</p>
      ) : (
        <>
          <label htmlFor={id}>Din e-mail</label>
          <div className="a-newsletter-fields">
            <input
              id={id}
              name="email"
              type="email"
              required
              placeholder="navn@eksempel.dk"
              autoComplete="email"
            />
            <button className="a-button" type="submit" disabled={pending}>
              {pending ? "Sender…" : "Tilmeld ↗"}
            </button>
          </div>
          <label className="a-consent">
            <input name="consent" type="checkbox" value="yes" required />
            Ja tak, I må kontakte mig om tilmelding til nyheder.
          </label>
          {state.message && <p role="alert">{state.message}</p>}
        </>
      )}
    </form>
  );
}
